<template>
  <div class="xv_view" id="Alerts_G">
    <div class="xv_top">
      <div>
        <label class="xv_view_title">Alerts</label>
      </div>
      <div class="xv_actions"></div>
    </div>

    <div class="xv_table">
      <div class="xv_table_title">
        <div>
          <span>Alerts (6)</span>
        </div>
        <div>
          <button class="sec_btn" @click="table_filter()">
            Filter
            <span class="mdi mdi-filter-menu"></span>
          </button>
        </div>
      </div>

      <div class="filter_wrap">
        <div class="left_filter" v-if="left_filter == true">
          <div class="header_section top">
            <div>
              <span class="main_title">
                Filter
                <span class="mdi mdi-filter-menu"></span>
              </span>
            </div>
            <div>
              <span class="option">Reset</span>
            </div>
          </div>
          <div class="section">
            <div class="header_section">
              <div>
                <span class="title">Date</span>
              </div>
              <div>
                <span class="option">Clear</span>
              </div>
            </div>

            <div class="content">
              <div class="xv_datepicker">
                <span class="mdi mdi-calendar-month"></span>
                <vc-date-picker
                  mode="range"
                  v-model="selectedDate"
                  :popover="{ visibility: 'click' }"
                  :input-props="{
                    class: 'picker_input',
                    placeholder: 'Select dates',
                    readonly: true
                  }"
                  :masks="{ input: 'DD/MM/YY' }"
                />
              </div>
            </div>
          </div>
          <div class="section">
            <div class="header_section">
              <div>
                <span class="title">Citizen</span>
              </div>
              <div>
                <span class="option">Clear</span>
              </div>
            </div>

            <div class="content">
              <input type="text" placeholder="Employee" />
            </div>
          </div>

          <div class="section">
            <div class="header_section">
              <div>
                <span class="title">Status</span>
              </div>
              <div>
                <span class="option">Clear</span>
              </div>
            </div>

            <div class="content">
              <div class="filter_checkbox">
                <div class="check">
                  <b-form-checkbox id="checkbox-5" name="checkbox-5"></b-form-checkbox>
                </div>
                <div>
                  <span class="check_label">Ok</span>
                </div>
              </div>
              <div class="filter_checkbox">
                <div class="check">
                  <b-form-checkbox id="checkbox-6" name="checkbox-6"></b-form-checkbox>
                </div>
                <div>
                  <span class="check_label">Block</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <table class="alerts_table_g">
          <thead>
            <tr>
              <th style>Date/Time</th>
              <th style="text-align:center">Citizen</th>
              <th style="text-align:center">Phone</th>
              <th style="text-align:center">Id</th>
              <th style="text-align:center">Status</th>
              <th style="text-align:center">Alert</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <span>02-Jan-2020 10:30am</span>
              </td>
              <td>
                <span class="e_name" @click="view_citizen">Ajay Herman</span>
              </td>
              <td>
                <span>+1-202-555-0189</span>
              </td>
              <td>
                <span>#987654</span>
              </td>
              <td class="status_1">
                <span>Ok</span>
              </td>
              <td>
                <span>Quarantine Violation</span>
              </td>
            </tr>

            <tr>
              <td>
                <span>02-Jan-2020 10:30am</span>
              </td>
              <td>
                <span class="e_name" @click="view_citizen">Saira Mays</span>
              </td>
              <td>
                <span>+1-202-555-0189</span>
              </td>
              <td>
                <span>#987654</span>
              </td>
              <td class="status_2">
                <span>Block</span>
              </td>
              <td>
                <span>Health Status Not Updated</span>
              </td>
            </tr>

            <tr>
              <td>
                <span>02-Jan-2020 10:30am</span>
              </td>
              <td>
                <span class="e_name" @click="view_citizen">Jules Case</span>
              </td>
              <td>
                <span>+1-202-555-0189</span>
              </td>
              <td>
                <span>#987654</span>
              </td>
              <td class="status_1">
                <span>Ok</span>
              </td>
              <td>
                <span>Quarantine Violation</span>
              </td>
            </tr>

            <tr>
              <td>
                <span>02-Jan-2020 10:30am</span>
              </td>
              <td>
                <span class="e_name" @click="view_citizen">Kaleb Read</span>
              </td>
              <td>
                <span>+1-202-555-0189</span>
              </td>
              <td>
                <span>#987654</span>
              </td>
              <td class="status_1">
                <span>Ok</span>
              </td>
              <td>
                <span>Health Status Not Updated</span>
              </td>
            </tr>

            <tr>
              <td>
                <span>02-Jan-2020 10:30am</span>
              </td>
              <td>
                <span class="e_name" @click="view_citizen">Loki Redmond</span>
              </td>
              <td>
                <span>+1-202-555-0189</span>
              </td>
              <td>
                <span>#987654</span>
              </td>
              <td class="status_1">
                <span>Ok</span>
              </td>
              <td>
                <span>Health Status Not Updated</span>
              </td>
            </tr>

            <tr>
              <td>
                <span>02-Jan-2020 10:30am</span>
              </td>
              <td>
                <span class="e_name" @click="view_citizen">Cleo Mccormick</span>
              </td>
              <td>
                <span>+1-202-555-0189</span>
              </td>
              <td>
                <span>#987654</span>
              </td>
              <td class="status_2">
                <span>Block</span>
              </td>
              <td>
                <span>Quarantine Violation</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Alerts_G",
  components: {},
  data() {
    return {
      selected: null,
      left_filter: false,
      selectedDate: null,
      multiselect: null
    };
  },
  methods: {
    table_filter: function() {
      if (this.left_filter == false) {
        this.left_filter = true;
      } else {
        this.left_filter = false;
      }
    },
    view_citizen: function() {
      this.$router.push("citizens");
    }
  }
};
</script>
